var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterIconStep1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1753",
    "data-name": "Group 1753",
    transform: "translate(-135 -915)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2422",
    "data-name": "Rectangle 2422",
    width: 71,
    height: 70,
    rx: 5,
    transform: "translate(135 915)",
    fill: "#005ae7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1640",
    "data-name": "Group 1640",
    transform: "translate(139 -33.362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5070",
    "data-name": "Path 5070",
    d: "M25.192,10a7.885,7.885,0,1,0,7.885,7.885A7.9,7.9,0,0,0,25.192,10Zm0,2.1a5.782,5.782,0,1,1-5.782,5.782A5.766,5.766,0,0,1,25.192,12.1Zm0,1.577a4.221,4.221,0,0,0-4.205,4.205,1.051,1.051,0,1,0,2.1,0,2.087,2.087,0,0,1,2.1-2.1,1.051,1.051,0,1,0,0-2.1Zm-.526,13.667A13.717,13.717,0,0,0,11,41.013a1.051,1.051,0,0,0,1.051,1.051H25.192a1.051,1.051,0,1,0,0-2.1H13.218A11.554,11.554,0,0,1,24.667,29.449h1.051a10.554,10.554,0,0,1,3.351.476,1.054,1.054,0,0,0,.657-2,12.868,12.868,0,0,0-4.008-.575Zm15.769,1.577a11.447,11.447,0,0,0-10.989,15.03,1.053,1.053,0,0,0,2-.624,9.6,9.6,0,0,1-.476-2.842,9.462,9.462,0,1,1,9.462,9.462,9.6,9.6,0,0,1-7.572-3.794,1.055,1.055,0,0,0-1.675,1.281,11.565,11.565,0,1,0,9.248-18.512Zm5.191,7.343a1.051,1.051,0,0,0-.706.345L39.3,42.688l-3.433-3.006a1.054,1.054,0,0,0-1.38,1.593l4.205,3.679a1.051,1.051,0,0,0,1.462-.082l6.308-6.833a1.051,1.051,0,0,0-.838-1.774Z",
    transform: "translate(0 952.362)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIconStep1);
export default __webpack_public_path__ + "static/media/footer-icon-step1.ad7d0a9a.svg";
export { ForwardRef as ReactComponent };